import React, { useRef, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import HomeBox from "../components/HomeBox";
import HomeBoxNotLive from "../components/HomeBoxNotLive";
import AmChartRingIndicator from "../../../components/AmChartRingIndicator";
import {functions} from "../../../constants/common-functions";

import {
  TRUE,
  COLOR_EDIT
} from "../../../constants/general-constants";

import {
  OMNISCAN_CORPORATE_GREEN,
  OMNISCAN_CORPORATE_GREEN_RGB
} from "../../../constants/colors";

export default function HomeBoxLeases({homeConfig}) {
  const history = useHistory();
  const boxRef = useRef(null);
  
  const [leasedProperties, setLeasedProperties] = useState(0);
  const [leasedPercentage, setLeasedPercentage] = useState(0);
  const [leasedSqFt, setLeasedSqFt] = useState(0);
  const [leasedRent, setLeasedRent] = useState(0);
  const [leasedQ1, setLeasedQ1] = useState(0);
  const [leasedQ2, setLeasedQ2] = useState(0);
  const [leasedQ3, setLeasedQ3] = useState(0);
  const [leasedQ4, setLeasedQ4] = useState(0);
  
  const [values, setValues] = useState([]);
  const [maxValue, setMaxValue] = useState(1);
  const [maxHeight, setMaxHeight] = useState(70);
 
  const [isLive, setIsLive] = useState(false);
  
  useEffect(() => {
  		if(homeConfig){
  			setIsLive(homeConfig.isLiveLinkLeases);
			runCounter(homeConfig.leasedProperties);
  			setLeasedPercentage(homeConfig.leasedPercentage);
			setLeasedRent(homeConfig.leasedRent);
			setLeasedSqFt(homeConfig.leasedSqft);
			setLeasedRent(homeConfig.leasedRent);
			setLeasedQ1(homeConfig.leasedQ1);
			setLeasedQ2(homeConfig.leasedQ2);
			setLeasedQ3(homeConfig.leasedQ3);
			setLeasedQ4(homeConfig.leasedQ4);
			
			setMaxHeight(70);
			let tempValues = [
			  homeConfig.leasedQ1 || 0,
			  homeConfig.leasedQ2 || 0,
			  homeConfig.leasedQ3 || 0,
			  homeConfig.leasedQ4 || 0
			];
			
			setValues(tempValues);
			setMaxValue(Math.max(...tempValues, 1));
			
  		}
  	}, [homeConfig]);
  
  const runCounter = (val) => {

    const target = val;
    let start = 0;

    const duration = 1000;
    const stepTime = 30;
    const steps = duration / stepTime;
    const increment = target / steps;

    const timer = setTimeout(() => {

      const counter = setInterval(() => {

        start += increment;

        if (start >= target) {
          start = target;
          clearInterval(counter);
        }

        setLeasedProperties(Math.round(start));

      }, stepTime);

    }, 1800); // delay slightly so chart appears first

    return () => clearTimeout(timer);

  };

  const goDashboardLease = () => {
    history.push("/dashboardlease");
  };

  // ---- Base panel container (rounded, premium, frosted) --------------------
  const panelStyle = {
	background: "linear-gradient(180deg, #FAFBFC 0%, #EEF1F5 100%)",
	  border: "1px solid rgba(0,0,0,0.06)",
	      boxShadow: "0 1px 4px rgba(0,0,0,0.10)",
    borderRadius: "8px",
    padding: "16px 20px",
    width: "calc(100% - 60px)",
    margin: "10px 10px",
   
  };

  // ---- Title section -------------------------------------------------------
  const titleStyle = {
    fontSize: "16px",
    fontWeight: 600,
    color: "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "10px",
  };

  // ---- KPI section ---------------------------------------------------------
  const kpiRow = {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px"
  };

  const kpiNumber = {
    fontSize: "36px",
    fontWeight: "700",
    color: "#222",
    marginRight: "12px",
    marginLeft: "6px",
    letterSpacing: "-0.5px"
  };

  const kpiLabel = {
    fontSize: "15px",
    fontWeight: 500,
    color: "#666"
  };

 

  // ---- Bubble section ------------------------------------------------------
  const bubbleContainer = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px"
  };

  const bubble = {
    flex: 1,
    margin: "10px",
    borderRadius: "3px",
    color: "white",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: `linear-gradient(180deg, ${OMNISCAN_CORPORATE_GREEN} 0%, #0a8040 100%)`,
    //boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
  };

  const quarterRow = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "-4px"
  };

  const quarterLabel = {
    flex: 1,
    margin: "8px",
    fontWeight: 600,
    color: "#444",
    textAlign: "center",
    fontSize: "14px"
  };
  
  
  const metricContainer = {
    marginTop: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "6px"
  };

  const metricRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 0",
    borderBottom: "1px solid rgba(0,0,0,0.06)"
  };

  const metricLabel = {
    fontSize: "13px",
    color: "#666",
    fontWeight: 500
  };

  const metricValue = {
    fontSize: "15px",
    fontWeight: 700,
    color: OMNISCAN_CORPORATE_GREEN,
    textShadow: `0 0 6px rgba(${OMNISCAN_CORPORATE_GREEN_RGB},0.25)`
  };
  
  
  // -------------------------------------------------------------------------
  // UI
  // -------------------------------------------------------------------------
  return (
    <HomeBox
      isLive={isLive}
      title="Leases"
      color={COLOR_EDIT}
      colorRgb={OMNISCAN_CORPORATE_GREEN_RGB}
      clickFunction={goDashboardLease}
      icon="calendar-alt"
      isLast={TRUE}
	  delay={840}
    >
      <div ref={boxRef} style={{ width: "100%", display: "flex", flexDirection: "column" }}>

        {/* ---------------- TOP PANEL ---------------- */}
        <div style={panelStyle}>
          <div style={titleStyle}>Leases</div>

          <div style={{ display: "flex", width: "100%" }}>
            {/* Doughnut */}
            <div style={{ width: "45%", display: "flex", justifyContent: "center" }}>
			<AmChartRingIndicator
			   percentage={leasedPercentage}
			   width={120}
			   height={120}
			   icon="chair"
			   color={OMNISCAN_CORPORATE_GREEN}
			   label="Leased"
			   id="portfolioleased"
			/>
             
            </div>

            {/* KPI + Table */}
            <div style={{ flex: 1 }}>
              <div style={kpiRow}>
                <div style={kpiNumber}>{functions.formatNumber(leasedProperties, 0)}</div>
                <div style={kpiLabel}>Properties</div>
              </div>

			  <div style={metricContainer}>

			    <div style={metricRow}>
			      <div style={metricLabel}>Sq Ft</div>
			      <div style={metricValue}>{functions.formatNumber(leasedSqFt, 0)}</div>
			    </div>

			    <div style={metricRow}>
			      <div style={metricLabel}>Rent</div>
			      <div style={metricValue}>${functions.formatNumber(leasedRent, 1)}M</div>
			    </div>

			  </div>
            </div>
          </div>
        </div>

        {/* ---------------- BOTTOM PANEL ---------------- */}
        <div style={{...panelStyle, marginTop:'0px'}}>
          <div style={{ ...titleStyle, marginBottom: "0px" }}>
            Available Break Options & Terminations
          </div>
		 
		  <div style={bubbleContainer}>
		    {values.length > 0 &&
		      (() => {
		        const maxVal = Math.max(...values, 1);

		        return values.map((val, i) => {
		          const height = Math.max((val / maxVal) * 70, 10);

		          return (
		            <div
		              key={i}
		              style={{
		                ...bubble,
		                height: height + "px",
		                transition: "height 0.4s ease"
		              }}
		            >
		             {val}K
		            </div>
		          );
		        });
		      })()}
		  </div>

          <div style={quarterRow}>
            <div style={quarterLabel}>Q1</div>
            <div style={quarterLabel}>Q2</div>
            <div style={quarterLabel}>Q3</div>
            <div style={quarterLabel}>Q4</div>
          </div>
        </div>

      </div>
    </HomeBox>
  );
}
